import { render, staticRenderFns } from "./ConfirmResignModal.vue?vue&type=template&id=c79174fe&scoped=true"
import script from "./ConfirmResignModal.vue?vue&type=script&lang=js"
export * from "./ConfirmResignModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmResignModal.vue?vue&type=style&index=0&id=c79174fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79174fe",
  null
  
)

export default component.exports